import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { ConfirmModal } from 'src/modules/shared';
import { Location } from '@angular/common';
import { FinanceService } from 'src/modules/features/contractor/services';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-pay-payment-instruction',
  templateUrl: './pay-payment-instruction.component.html',
  styleUrls: ['./pay-payment-instruction.component.scss'],
})
export class PayPaymentInstructionComponent implements OnInit {
  baseUrl: string = environment.API_SERVER;
  webUrl: string = environment.WEB;
  projectId: string;
  pendingArr: boolean[] = [];
  paymentForm: FormGroup;

  purpose: string;
  amount: any = 0;
  beneficiary: string;
  rrr: string;
  paymentUrl: string;
  description: string;
  address: string;
  name: string;
  phone: string;
  email: string;
  paymentLink: string;
  paymentType: string;
  currencyCode: string;
  docPath: string;
  invoiceNumber!: string;
  invoice: any;
  invoicePayment: any;
  paid: boolean = false;
  invoiceNo;
  initiatedPaymentId;
  transactionRef;
  internalTransactionRef;
  paymentRedirect: boolean = false;
  paymentComplete: boolean = false;
  pending: boolean = false;
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private financeSvc: FinanceService
  ) {
    this.getConfig('REMITA_PAYMENT_REDIRECT');
    this.activatedRoute.queryParams.subscribe((params) => {
      this.paid = params['status'] === 'PAID' ? true : false;
      this.invoiceNumber = params['invoiceNumber'];
      this.transactionRef = params['transactionRef'];
      if (this.invoiceNumber) {
        this.getInvoice(this.invoiceNumber);
        this.getInvoicePayment(this.invoiceNumber);
        this.beneficiary = 'Nigerian Communications Commission';
      } else if (this.transactionRef) {
        this.pending = true;
        this.financeSvc.getPaymentStatus({ id: this.transactionRef }).subscribe(
          (res: any) => {
            this.paymentType =
              res['payment']['paymentDetails']['currencyId'] == 'naira'
                ? 'LOCAL'
                : 'FOREIGN';
            this.purpose = params['purpose'] ? params['purpose'] : 'Fees';
            this.amount = res['amount'];
            this.currencyCode = res['currencyCode'];
            this.beneficiary = 'Nigerian Communications Commision';
            this.rrr = res.payment['transactionRef'];
            this.description = res['payment']['description']
              ? res['payment']['description']
              : res['payment']['paymentDetails']['invoice_description'];
            this.address = res['payment']['paymentDetails']['payers_address'];
            this.name = res['payment']['paymentDetails']['payers_name'];
            this.phone = res['payment']['paymentDetails']['payers_phone'];
            this.email = res['payment']['paymentDetails']['payers_email'];
            this.docPath = res['payment']['detailsDocumentPath'];
            this.paymentLink = res['paymentUrl']
              ? res['paymentUrl']
              : res['payment']['paymentUrl'];
            this.invoiceNo = res['payment']['paymentDetails']['invoice_number'];
            this.initiatedPaymentId = res['payment']['initiatedPaymentId'];
            this.internalTransactionRef =
              res['payment']['internalTransactionRef'];
            this.pending = false;
          },
          (error) => {
            this.pending = false;
          }
        );
      } else {
        this.projectId = params['id'];
        this.paymentType = params['paymentType'];
        this.paymentUrl = params['paymentUrl'];
        this.purpose = params['purpose'];
        this.amount = params['amount'];
        this.currencyCode = params['currencyCode'];
        this.beneficiary = params['beneficiary'];
        this.rrr = params['rrr'];
        this.description = params['description'];
        this.address = params['address'];
        this.name = params['name'];
        this.phone = params['phone'];
        this.email = params['email'];
        this.docPath = params['docPath'];
        this.paymentLink = params['paymentLink'];
        this.internalTransactionRef = params['internalTransactionRef'];
      }
    });
    this.paymentForm = fb.group({
      invoiceNumber: [''],
      currencyId: [''],
      paymentType: [''],
      payerName: [''],
      payerPhone: [''],
      payerEmail: [''],
      payerAddress: [''],
      description: [''],
      invoiceDescription: [''],
      companyName: [''],
      gifmisCode: [''],
      amount: [''],
      revenueServiceId: [''],
    });
  }
  getConfig(configId: string) {
    this.pending = true;
    this.financeSvc.getPaymentConfig({ configId: configId }).subscribe(
      (res) => {
        this.paymentRedirect = res.value === 'true' ? true : false;
        this.pending = false;
      },
      (error) => {
        this.pending = false;
      }
    );
  }
  deleteLot() {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Award?',
          'Are you sure you want to delete selected Award?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
  goBack() {
    this.location.back();
  }

  getInvoice(invoiceNumber: string) {
    this.callStarted();
    this.financeSvc.getInvoiceDetail({ params: { invoiceNumber } }).subscribe(
      (res) => {
        console.log(res);
        this.invoice = res;
        this.currencyCode = res['currencyCode'];
        this.amount = res['amount'];
        this.purpose = res['categoryName'];
        this.description = res['description'];
        this.callCompleted();
      },
      (error) => {
        this.callCompleted();
      }
    );
  }

  getInvoicePayment(invoiceNumber: string) {
    this.callStarted();
    this.financeSvc.getInvoicePayment({ params: { invoiceNumber } }).subscribe(
      (res: any) => {
        console.log(res);
        this.invoicePayment = res;
        this.paymentUrl = res['paymentUrl'];
        this.rrr = res['transactionRef'];
        this.address = res['paymentDetails']['payers_address'];
        this.name = res['paymentDetails']['payers_name'];
        this.phone = res['paymentDetails']['payers_phone'];
        this.email = res['paymentDetails']['payers_email'];
        this.docPath = res['detailsDocumentPath'];
        this.paymentLink = res['paymentUrl'];
        this.initiatedPaymentId = res['initiatedPaymentId'];
        this.internalTransactionRef = res['internalTransactionRef'];
        this.callCompleted();
      },
      (error: any) => {
        console.log(error);
        this.callCompleted();
      }
    );
  }

  callStarted() {
    this.pendingArr.push(true);
  }
  success: boolean = false;
  error: boolean = false;
  closeMessage() {
    this.success = false;
    this.error = false;
  }
  callCompleted() {
    this.pendingArr.pop();
  }
  generateTransactionID(length = 13) {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let transactionID = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      transactionID += characters[randomIndex];
    }
    return transactionID;
  }
  makePayment() {
    const transactionId = this.generateTransactionID();
    console.log(transactionId, 'transacionId');
    this.financeSvc.makePayment2(
      transactionId,
      this.rrr,
      this.handleSuccess.bind(this),
      this.handleError.bind(this),
      this.handleClose.bind(this)
    );
  }
  handleSuccess(response: any) {
    console.log('Payment successful:', response);
    this.registerFinance();
  }

  handleError(response: any) {
    console.log('Payment error:', response);
    this.error = true;
  }

  handleClose() {
    console.log('Payment widget closed');
    document.body.classList.remove('no-scroll');
    document.body.classList.add('scroll');
    console.log(this.internalTransactionRef, 'refnew');
  }
  registerFinance() {
    this.pending = true;
    this.financeSvc
      .financeRemitaCallback({ refId: this.internalTransactionRef })
      .subscribe(
        (res) => {
          if (res.status === 200) {
            this.success = true;
            this.paymentComplete = true;
          } else {
            this.error = true;
          }
          this.pending = false;
        },
        (error) => {
          if (error.status === 200) {
            this.success = true;
            this.paymentComplete = true;
          } else {
            this.error = true;
          }
          this.pending = false;
        }
      );
  }
  ngOnInit(): void {}
}
